const getters = {
  getInvoice: (state) => state.invoice,
  getInvoiceList: (state) => state.invoiceList,
  getInvoiceListMeta: (state) => state.invoiceListMeta,
  getSelectedInsurer: (state) => state.selectedInsurer,
};

export default getters;
